import {
  REPORT_TRANSACTIONS_CHARGEBACK_SUCCESS,
  REPORT_TRANSACTIONS_CHARGEBACK_FAILURE,
  CLEAN_DETAILS_PREPAID_CHARGEBACK,
  CLEAN_DETAILS_PREPAID_CHARGEBACK_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function chargebackReducer(state = initialState, action) {
  switch (action.type) {
    case REPORT_TRANSACTIONS_CHARGEBACK_SUCCESS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case REPORT_TRANSACTIONS_CHARGEBACK_FAILURE:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAILS_PREPAID_CHARGEBACK:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAILS_PREPAID_CHARGEBACK_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };

    default:
      return state;
  }
}
